import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddExtraInformationForm from './AddExtraInformationForm.jsx';
//  import useLookupModule from '../../../../hooks/Lookups/use-Lookup-Module.js';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import ModalComponent from '../../../../components/Modal/ModalComponent.jsx';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import useGetDynamicForm from '../../../../hooks/Forms/useGetDynamicForm.js';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';
import EditExtraInformationForm from './EditExtraInformationForm.jsx';

const ExtraInformationForm = () => {
  const { HasPermission } = usePermissions();

  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const [item, setItem] = useState(null);
  const Navigate = useNavigate();
  // const [selectedValue, setSelectedValue] = useState('');
  // const { Module } = useLookupModule();
  //__________________________________________________

  const { DynamicExtraInformation, loading } = useGetDynamicForm();

  //_________________________________________________________________________________________________

  const filtered = DynamicExtraInformation?.slice()?.filter((item) => {
    const searchLowerCase = search.toLowerCase();
    return (
      item.name?.toLowerCase().includes(searchLowerCase) ||
      item.name2?.toLowerCase().toString().includes(searchLowerCase)
    );
  });
  // ?.filter((item) => (selectedValue === '' ? true : item.moduleId === selectedValue));

  const columns = [
    { title: t('Name'), key: 'Name', className: 'w-25' },
    { title: t('Application'), key: 'Application', className: 'w-25' },
    { title: t('Table'), key: 'Table', className: 'w-25' },
    { title: t(''), key: 'action', className: 'text-end w-25' },
  ];

  const tableData = filtered?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      Application: i18n.language === 'en' ? item.moduleName : item.moduleName2,
      Table: i18n.language === 'en' ? item.tableName : item.tableName2,
      action: (
        <div className="btn-group">
          {HasPermission('NtxAddingfieldstoExtraInformationform') && (
            <button
              type="button"
              onClick={() => Navigate(`/NTX/Forms/${item.id}/AddFormColumns`)}
              className="btn btn-sm btn-outline-theme  ">
              <i className="fab fa-lg fa-fw fa-elementor ms-1"></i>
              {t('fieldsForm')}
            </button>
          )}

          {HasPermission('NtxEditExtraInformationform') && (
            <button
              type="button"
              // onClick={() => Navigate(`${item.id}/EditExtraInformationForm`)}
              onClick={() => setItem(item)}
              data-bs-toggle="modal"
              data-bs-target="#modalEditForm"
              className="btn btn-sm btn-outline-theme  ">
              <i className="far fa-lg fa-fw fa-edit me-1"></i>
              {t('Button.Edit')}
            </button>
          )}
        </div>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });
  
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: t('Extra Information Forms'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Extra Information Forms')} />
        <div className="ms-auto">
          {HasPermission('NtxAddExtraInformationform') && (
            <Link
              tp=""
              className="btn btn-theme"
              data-bs-toggle="modal"
              data-bs-target="#modalAddForm"
              onClick={() => setShow(true)}>
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddForm')}
            </Link>
          )}
        </div>
      </div>

      <Card>
        <CardBody>
          <Loading loading={loading}>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </Loading>
        </CardBody>
      </Card>

      <ModalComponent title={t('AddExtraInfoForm')} id="modalAddForm" size="lg">
        {Show && <AddExtraInformationForm />}
      </ModalComponent>
      <ModalComponent title={t('EditForm')} id="modalEditForm" size="lg">
        {item && <EditExtraInformationForm id={item.id} />}
      </ModalComponent>
    </>
  );
};

export default ExtraInformationForm;
